/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useThemeStyle } from '../hooks/useThemeStyle';
import { TextSkeleton } from './TextSkeleton';
import { Skeleton } from './Skeleton';
import { BadgeSkeleton } from './BadgeSkeleton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons';
export var FatRowSkeleton = function (_a) {
    var className = _a.className, title = _a.title, meta = _a.meta, actions = _a.actions, right = _a.right, left = _a.left, checked = _a.checked;
    var css = useThemeStyle('fatRow', {
        display: 'flex',
        flexDirection: ['column', 'row'],
        alignItems: ['stretch', 'center'],
        mx: 2,
    });
    return (jsx("div", { css: css, className: className },
        jsx("div", { sx: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                flex: 1,
            } },
            checked && (jsx("div", { sx: { mr: 3 } },
                jsx(FontAwesomeIcon, { icon: faCheck, sx: { color: 'grey' } }))),
            left && (jsx("div", { sx: { mr: 3 } }, left === true ? (jsx(Skeleton, { sx: { borderRadius: 15, width: 30, height: 30 } })) : (left))),
            jsx("div", null,
                jsx("div", null, title || jsx(TextSkeleton, { sx: { width: 150 } })),
                meta && (jsx("div", { sx: { fontSize: 1 } }, meta === true ? jsx(TextSkeleton, { sx: { width: 120 } }) : meta)))),
        (right || actions) && (jsx("div", { sx: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
            } },
            right && (jsx("div", { sx: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    flexGrow: 1,
                } }, right === true ? jsx(BadgeSkeleton, { sx: { ml: ['auto'] } }) : right)),
            actions && (jsx("div", { sx: { ml: ['auto', undefined], pl: 2 } }, actions === true ? (jsx(FontAwesomeIcon, { icon: faEllipsisH, sx: { color: 'grey', m: 2 } })) : (actions)))))));
};
//# sourceMappingURL=FatRowSkeleton.js.map